import { UserInfo } from 'hub-http/userInfo';

export const getUserHasZorseChatScope = (userInfo?: Partial<UserInfo>) => {
  return userInfo?.user?.scopes?.includes('zorse-chat');
};

export const getUserHasZorseWebticketScope = (userInfo?: Partial<UserInfo>) => {
  return userInfo?.user?.scopes?.includes('zorse-webticket');
};
